import React from "react";
import { Container, Row, Col } from "shards-react";

import PageTitle from "../../components/common/PageTitle";

import { Link } from "react-router-dom";
import AddMyDesk from "../../components/appFrontend/AddMyDesk";


const AddToMyDesk = () => (
  <Container fluid className="main-content-container px-4">
    <Row noGutters className="page-header py-4">
      <PageTitle title="Mijn bureau" subtitle="APM-tool " md="12" className="ml-sm-auto mr-sm-auto" />
      <Link to={{pathname: `/mijn-bureau`,state: {}}} >Terug</Link>

    </Row>
    <AddMyDesk />
    
  </Container>
);

export default AddToMyDesk;
